import { CookiesConfig } from '@configs';
import { CookiePrivacyPreference } from '@store';
import { CookiesCookieOut, CookiesFamilyOut } from '@types';

const transformCookieStringToObject = (cookie?: string) => {
	if (!cookie) {
		return;
	}

	// Regular expression to match the string between '=' and '#'
	const regex = /cv=(.*?)#/;
	const version = regex.exec(cookie)?.[1];

	if (!version) {
		return;
	}

	return {
		version,
	};
};

const transformCookieStateToString = (version?: string, preferences?: CookiePrivacyPreference[]) => {
	if (!version || !preferences?.length) {
		return '';
	}

	let output = '';
	preferences.forEach((p) => {
		const value = p.accepted ? 'S' : 'N';
		output += `${p.idFamily}:${value}|`;
	});

	return `cv=${version}##${output}`;
};

const getPrivacyCookie = (cookiesOut?: CookiesCookieOut[], familiesOut?: CookiesFamilyOut[]) => {
	const privacyCookieOut = cookiesOut?.find(
		(c) => c.cookieName === CookiesConfig.privacyRules && c.cookieCode?.includes('E')
	);

	const defaultPrivacyPreferences = familiesOut?.map(({ isDefault, ...family }) => ({
		...family,
		accepted: isDefault,
	}));

	if (!privacyCookieOut) {
		return;
	}

	return {
		metadata: {
			name: privacyCookieOut.cookieName,
			version: privacyCookieOut.cookieVersion,
			expirationTime: privacyCookieOut.expirationTime,
		},
		preferences: defaultPrivacyPreferences,
	};
};

const getRemarketingCookie = (cookiesOut?: CookiesCookieOut[]) => {
	const remarketingCookieOut = cookiesOut?.find((c) => c.cookieName === CookiesConfig.remarketing);

	if (!remarketingCookieOut) {
		return;
	}

	return {
		metadata: {
			name: remarketingCookieOut.cookieName,
			expirationTime: remarketingCookieOut.expirationTime,
		},
		accepted: false,
	};
};

/**
 * Returns a Date object representing the current date + minutes provided.
 * @param minutes - Number of minutes to add (defaults to 43200 = 30 days)
 */
const getCookieExpirationDate = (minutes = 43200): Date => {
	const currentDateTime = new Date();
	return new Date(currentDateTime.getTime() + minutes * 60000);
};

export const helpers = {
	transformCookieStringToObject,
	transformCookieStateToString,
	getPrivacyCookie,
	getRemarketingCookie,
	getCookieExpirationDate,
};
